export class DataCatalogSemanticLayerRun {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "runId",
            "baseName": "runId",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "string",
            "format": ""
        },
        {
            "name": "startedAt",
            "baseName": "startedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "finishedAt",
            "baseName": "finishedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "error",
            "baseName": "error",
            "type": "string",
            "format": ""
        },
        {
            "name": "resultingVersion",
            "baseName": "resultingVersion",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "isActive",
            "baseName": "isActive",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "trigger",
            "baseName": "trigger",
            "type": "string",
            "format": ""
        },
        {
            "name": "triggeredBy",
            "baseName": "triggeredBy",
            "type": "string",
            "format": ""
        },
        {
            "name": "tableCount",
            "baseName": "tableCount",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "warningCount",
            "baseName": "warningCount",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "diffSummary",
            "baseName": "diffSummary",
            "type": "{ [key: string]: any; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogSemanticLayerRun.attributeTypeMap;
    }
    constructor() {
    }
}
